import React, { ComponentProps } from 'react'
import SyncIcon from '@mui/icons-material/Sync'
import { makeStyles } from 'tss-react/mui'
import { keyframes } from 'tss-react'
/**
 * Renders a loading spinner that can be used exactly like a Material-UI icon (e.g. on buttons and lists).
 */

const useStyles = makeStyles()({
  icon: {
    animation: `${keyframes`
      from {
        transform: rotate3d(0, 0, 1, 0deg) scaleX(-1);
      }
      to {
        transform: rotate3d(0, 0, 1, 180deg) scaleX(-1);
      }
    `} 1s linear infinite`,
  },
})

interface ILoadingIconProps extends ComponentProps<typeof SyncIcon> {
  spin?: boolean
}

const LoadingIcon = ({ spin = true, ...props }: ILoadingIconProps) => {
  const { classes } = useStyles()

  return (
    <SyncIcon {...props} className={spin ? classes.icon : undefined} />
  )
}

export default React.memo(LoadingIcon)
